/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Price_RentInputs */

const cs_form_price_rent = /** @type {(inputs: Form_Price_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nájem / měsíc`)
};

const en_form_price_rent = /** @type {(inputs: Form_Price_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent / month`)
};

/**
* | output |
* | --- |
* | "Rent / month" |
*
* @param {Form_Price_RentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_price_rent = /** @type {((inputs?: Form_Price_RentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Price_RentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_price_rent(inputs)
	return cs_form_price_rent(inputs)
});